var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.751 10h3.067l-6.7 8.472L30 30h-6.172l-4.833-6.992L13.464 30h-3.07l7.167-9.061L10 10h6.328l4.37 6.39L25.75 10Zm-1.076 17.97h1.7l-10.97-16.046H13.58L24.675 27.97Z"
  })));
};
export default SvgTwitter;